<template>
  <div class="d-flex flex-column">
    <div class="container-fluid">
      <div class="d-flex">
        <h1 class="mr-auto">Категории</h1>
        <select v-model="selectedMachineType" class="custom-select mt-2" style="max-width: 20em;">
          <option v-for="type in machineTypes" :value="type.value">{{type.name}}</option>
        </select>
        <button class="btn btn-primary my-1 mx-2" @click="edit(null)">Добавить категорию</button>
      </div>
    </div>
    <template v-if="categories">
    <data-table :data="categories">
      <el-table-column prop="name" label="Название"/>
      <el-table-column prop="from" label="От" align="center"/>
      <el-table-column prop="to" label="До" align="center"/>
      <el-table-column prop="color" label="Цвет">
        <template slot-scope="{row}">
          <div class="d-flex justify-content-center">
          <div class="color-preview" :style="'background-color: ' + (row.color ? row.color : '#000000') + '!important;'"></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="" align="right">
        <template slot-scope="{row}">
          <button class="btn btn-outline-light mr-1" @click="remove(row)">Удалить</button>
          <button class="btn btn-outline-light" @click="edit(row)">Редактировать</button>
        </template>
      </el-table-column>
    </data-table>
    </template>
  </div>
</template>

<script>
  import api from '@/api'
  import CategoryModal from '../../components/category-modal.vue'

  export default {
    metaInfo: {title: 'Категории'},
    data: () => {
      return {
        machineTypes: [
          {value: 'coffee', name: 'Кофейный'},
          {value: 'snack', name: 'Снековый'},
          {value: 'sparka', name: 'Спарка'},
        ],
        selectedMachineType: 'coffee',
      }
    },
    methods: {
      edit (category) {
        this.$root.showModal(CategoryModal, {
          categoryData: category,
          machineType: this.machineTypes.find((el) => {return el.value == this.selectedMachineType}).name
        })
          .then((data) => {
            if (data) {
              if (category) {
                Object.assign(category, data)
              } else {
                this.categories.push(data)
              }
            }
          })
      },
      remove (category) {
        if (!window.confirm('Подтвердить удаление?')) return

        return api.delete('categories/' + category.id).then(() => {
          this.categories.splice(this.categories.indexOf(category), 1)
        })
      },
    },
    asyncComputed: {
      categories () {
        return api.get('categories?type=' + this.selectedMachineType)
          .then(({data}) => data)
      }
    }
  }
</script>

<style lang="scss">
  .color-preview {
    width: 70px;
    height: 30px !important;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/categories.vue